export enum OrderStatus {
  DRAFT = 'DRAFT',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  CLEARING = 'CLEARING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}
